import React from "react";
import Layout from "../../layout";
import { HiLocationMarker } from "react-icons/hi"
import TabsSwitch from "../../components/pages_components/contact/TabsSwitch";
import StepperSwitch from "../../components/pages_components/contact/StepperSwitch";



const Contact = () => {


    const addressBlocks = [
        {
            location: "Canada",
            address: "Box 610 Fredericton, New Brunswick, E3B5A6"
        },
        {
            location: "Pakistan",
            address: "Office #A-504, Fortune Tower, 43/1-B, Block-6 PECHS, Karachi, Sindh"
        },
        {
            location: "Singapore",
            address: "8 EU Tong Sen Street #11-96/97, The Central Singapore (059818)"
        },
    ]


    return (
        <Layout>
            <div className="contact relative">
                <div className="wrapper">
                    {/* hero section */}
                    <div className="heroWrapper relative w-[20rem] sm:w-[40rem] lg:w-[80vw] mx-auto">
                        <div className="hero relative my-10  lg:w-[38rem] mx-auto">
                            <div className="heroTexts text-center">
                                {/* title */}
                                <h1 className="text-[1.5rem] lg:text-[2rem] font-bold text-center 2xl:text-[48px] capitalize text-[#333333]">
                                    reach out to us
                                </h1>

                                {/* description */}
                                <p className="mt-5 text-center text-sm lg:text-md lg:w-[25rem] lg:mx-auto 2xl:text-[28px] 2xl:w-full 2xl:leading-[30px]">
                                    Please fill out the form below to discuss your hiring project
                                    or receive a custom quote.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
                {/* section 2 */}
                {

                    window.innerWidth < 640 ?
                        <StepperSwitch />
                        :

                        <TabsSwitch />
                }



                {/* section2 end */}

                {/* address blocks START */}
                <div className="addressBanner lg:relative lg:h-[8rem] xl:h-[13rem] 2xl:h-[15rem] mt-5 bg-white">


                    <div className="addressBlocks flex flex-col items-center lg:flex-row lg:justify-around lg:w-[70rem] 2xl:w-[90vw] lg:mx-auto py-10 lg:py-5 xl:py-10 px-28 lg:absolute lg:top-0 ml-auto mr-auto lg:left-0 lg:right-0 ">
                        {
                            addressBlocks.map((block, index) =>
                                <div key={`div${block.location + index}`} className="addrBlock w-[20rem]  h-[10rem] p-4 bg-[#333333] text-[#FFD700] lg:mt-0 mt-5 lg:h-[180px] lg:w-[250px] xl:h-[220px] xl:w-[280px] 2xl:w-[350px] 2xl:h-[270px] 2xl:p-6 rounded-lg">
                                    <HiLocationMarker className='text-[1.9rem] md:text-[2.5rem] lg:text-[3rem] xl:text-[3.5rem]  xl:my-5 2xl:text-[4rem] 2xl:my-6 text-[#FFD700]' />

                                    <h4 className="font-bold mt-5 2xl:text-[24px] lg:mb-4 xl:mb-4 2xl:mb-4">{block.location}</h4>
                                    <p className="text-xs font-thin mt-2 2xl:text-[16px] 2xl:leading-[26px] lg:text-xs">{block.address}</p>
                                </div>
                            )
                        }
                    </div>

                </div>
                {/* address blocks end */}

                <div className="pageEnd">
                    <svg
                        viewBox="0 0 500 150"
                        preserveAspectRatio="none"
                        style={{ height: "12rem", width: "100%" }}

                    >
                        <path
                            d="M-3.76,53.79 C161.02,147.54 334.84,150.50 500.00,49.99 L500.00,0.00 L0.00,0.00 Z"
                            style={{ stroke: "none", fill: "#F7F7F7" }}
                        />
                    </svg>
                </div>
            </div>
        </Layout>
    );
};

export default Contact;
